import styled, { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    margin: 0;
    font-size: 14px;
    padding: 0;
    font-family: 'Roboto', sans-serif;
    line-height: 1.2;
    box-sizing: border-box;
  }

  h1, h2, h3{
    font-family: 'JetBrains Mono', monospace;
  }

  #main {
    position: absolute;
    top: 0;
    width: 60%;
    left: 40%;

    @media(max-width: 768px) {
      position: static;
      width: 100vw;
      overflow-x: hidden;
    }
  }

  body {
    background: #fff;
  }
`;

export const Checkbox = styled.div`
  margin: 10px 50px 0;

  label {
    line-height: 20px;

    input {
      margin-right: 5px;
    }

    a {
      color: #337ab7;
      text-decoration: none;
    }

    a:hover {
      color: #23527c;
      text-decoration: underline;
    }
  }

  @media (min-width: 280px) {
    margin-left: 10px;
    width: 100%;
  }
`;

export const Error = styled.span`
  color: #f00;
  text-align: center;
  margin: 10px auto;
  display: block;
`;
